import { Injectable, Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { LayoutService } from './layout.service';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit {
  routeData = new BehaviorSubject<any>('');
  routeData$ = this.routeData.asObservable();
  user$: Observable<firebase.User | null>
  constructor(private http: HttpClient, private dataService: LayoutService, private afAuth: AngularFireAuth) {
  this.user$ = afAuth.authState
  }

  ngOnInit() { }

  login(email: string, password: string) {
    return this.afAuth.signInWithEmailAndPassword(email, password);
  }

  firebaseLogout() {
    return this.afAuth.signOut();
  }

  getAccessToken() {
    return ""
    //return localStorage.getItem('access_token');
  }

  getAssociatedAccounts() {
    let userObj = JSON.parse(localStorage.getItem('userObject'));
    let sapId = userObj.associatedAccounts[0].facilitySAPId;
    return sapId;
  }

  getCRMId() {
    let defaultId = localStorage.getItem('defaultID');
    let userObj = JSON.parse(localStorage.getItem('userObject'));
    let crmId = defaultId != null && defaultId != '' ? defaultId : userObj.associatedAccounts[0].facilityCRMId;
    return crmId;
  }
  setAccessToken(data) {
    localStorage.setItem('access_token', data);
  }
  // setSessionId(data){
  //   localStorage.setItem('session_id',data);
  // }
  setExpiresIn(data) {
    localStorage.setItem('expires_in', data);
  }
  setExtExpiresIn(data) {
    localStorage.setItem('ext_expires_in', data);
  }
  setTimeSec(data) {
    localStorage.setItem('cur_time', data);
  }
  getTimeSec() {
    return localStorage.getItem('cur_time');
  }
  getRefreshToken() {
    return ""
    //return localStorage.getItem('refresh_token');
  }
  setRefreshToken(data) {
    localStorage.setItem('refresh_token', data);
  }
  getToken() {
    return localStorage.getItem('token');
  }
  setToken(data) {
    localStorage.setItem('token', data);
  }
  getCountryVal() {
    return localStorage.getItem('countryVal');
  }
  setCountryVal(data) {
    localStorage.setItem('countryVal', data);
  }
  getUserToken() {
    return localStorage.getItem('user_token');
  }
  setUserToken(data) {
    localStorage.setItem('user_token', data);
  }
  getRole() {
    return localStorage.getItem('role');
  }
  setRole(data) {
    localStorage.setItem('role', data);
  }
  getDisplay() {
    return localStorage.getItem('dispName');
  }
  setDisplay(data) {
    localStorage.setItem('dispName', data);
  }
  setUserProfileObject(data) {
    localStorage.setItem('userObject', JSON.stringify(data));
  }
  getUserProfileObject() {
    return JSON.parse(localStorage.getItem('userObject'));
  }
  setUserPlanObject(data) {
    localStorage.setItem('subscriptionObject', JSON.stringify(data));
  }
  getUserPlanObject() {
    return JSON.parse(localStorage.getItem('subscriptionObject'));
  }
  setSelectedAPP(data) {
    localStorage.setItem('selectedApplications', JSON.stringify(data));
  }
  getSelectedAPP() {
    return JSON.parse(localStorage.getItem('selectedApplications'));
  }
  setPolicyData(data) {
    localStorage.setItem('policyData', JSON.stringify(data));
  }
  getPolicyData() {
    return JSON.parse(localStorage.getItem('policyData'));
  }
  setLanguageObject(data) {
    localStorage.setItem('langObject', JSON.stringify(data));
  }
  getLanguageObject() {
    return JSON.parse(localStorage.getItem('langObject'));
  }
  setSessionId(data) {
    localStorage.setItem('sessionId', data);
  }
  loggedIn() {
    return (!!localStorage.getItem('access_token') && !!localStorage.getItem('refresh_token'))
  }
  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('dispName');
    localStorage.removeItem('token');
    localStorage.removeItem('cur_time');
    localStorage.removeItem('role');
    localStorage.removeItem('Lang');
    localStorage.removeItem('pId');
    localStorage.removeItem('countryVal');
    localStorage.removeItem('user_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('Application');
    localStorage.removeItem('userObject');
    localStorage.removeItem('subscriptionObject');
    localStorage.removeItem('selectedApplications');
    localStorage.removeItem('langObject');
    localStorage.removeItem('defaultID');
    localStorage.removeItem('policyData');
    localStorage.removeItem('featureList');
    this.dataService.changeExpandValue(true)
  }
}
